import { SettingsSection } from './SettingsSection';
import { DetailTranslationKeys, SettingsTranslationKeys } from '../../../api/models/TranslationKeys';
import { SettingsOptionButton } from '../components/SettingsOptionButton';
import { SubscriptionSettings } from '../../../Business/detail/actions/epgRecordingActions/SubscriptionSettings.types';
import { CheckBox } from '../../detail/recording/CheckBox';
import { NpvrSettingsKeys } from '../../../api/models/NpvrSettingsKeys';

export class RecordingSection extends SettingsSection {
  /**
   * @param {Backend} backend
   */
  constructor(backend) {
    super(backend, backend.translations.forKey(SettingsTranslationKeys.settings_title_recording_npvr_android_tv));
    let initialType = undefined;
    let initialBegin = undefined;
    let initialEnd = undefined;
    let initialProtected = undefined;
    this.loadDataPromise = Promise.all([
      backend.cachedNpvrSettings.getSetting(backend, NpvrSettingsKeys.recording_episodes),
      backend.cachedNpvrSettings.getSetting(backend, NpvrSettingsKeys.recording_before_time),
      backend.cachedNpvrSettings.getSetting(backend, NpvrSettingsKeys.recording_after_time),
      backend.cachedNpvrSettings.getSetting(backend, NpvrSettingsKeys.recording_delete_protection),
    ])
      .then(res => {
        if (res[0]) {
          initialType = res[0].value;
        }
        if (res[1]) {
          initialBegin = res[1].value;
        }
        if (res[2]) {
          initialEnd = res[2].value;
        }
        if (res[3]) {
          initialProtected = res[3].value;
        }
      })
      .then(() => {
        this.subscriptionSettings = new SubscriptionSettings(
          this.backend,
          this.backend.sessionInfo.npvr.id,
          initialType,
          initialBegin,
          initialEnd,
          initialProtected
        );
      });
  }

  addControls(list) {
    super.addControls(list);
    const typeElement = list.items.childList.a({
      type: SettingsOptionButton,
      data: {
        label: this.backend.translations.forKey(SettingsTranslationKeys.settings_recording_episodes_stb),
        options: [],
        value: null,
      },
      passSignals: {
        onActivate: true,
      },
    });

    const beginElement = list.items.childList.a({
      type: SettingsOptionButton,
      data: {
        label: this.backend.translations.forKey(DetailTranslationKeys.detail_recording_change_rec_option_before),
        options: [],
        value: null,
      },
      passSignals: {
        onActivate: true,
      },
    });

    const endElement = list.items.childList.a({
      type: SettingsOptionButton,
      data: {
        label: this.backend.translations.forKey(DetailTranslationKeys.detail_recording_change_rec_option_after),
        options: [],
        value: null,
      },
      passSignals: {
        onActivate: true,
      },
    });

    let protectedRec = list.items.childList.a({
      type: CheckBox,
      y: 8,
    });

    this.loadDataPromise.then(() => {
      const programOptions = this.subscriptionSettings.subscriptionTypes;
      let selectedType = programOptions[this.subscriptionSettings.defaultTypeIndex];
      typeElement.data = {
        label: this.backend.translations.forKey(SettingsTranslationKeys.settings_recording_episodes_stb),
        options: programOptions,
        value: selectedType,
        action: ctrl => {
          this.backend.cachedNpvrSettings.setSetting(
            this.backend,
            NpvrSettingsKeys.recording_episodes,
            ctrl.data.value.value
          );
        },
      };

      const beginOptions = this.subscriptionSettings.beginBufferOptions;
      let selectedBegin = beginOptions[this.subscriptionSettings.defaultBeginIndex];
      beginElement.data = {
        label: this.backend.translations.forKey(DetailTranslationKeys.detail_recording_change_rec_option_before),
        options: beginOptions,
        value: selectedBegin,
        action: ctrl => {
          this.backend.cachedNpvrSettings.setSetting(
            this.backend,
            NpvrSettingsKeys.recording_before_time,
            ctrl.data.value.value
          );
        },
      };

      const endOptions = this.subscriptionSettings.endBufferOptions;
      let selectedEnd = endOptions[this.subscriptionSettings.defaultEndIndex];
      endElement.data = {
        label: this.backend.translations.forKey(DetailTranslationKeys.detail_recording_change_rec_option_after),
        options: endOptions,
        value: selectedEnd,
        action: ctrl => {
          this.backend.cachedNpvrSettings.setSetting(
            this.backend,
            NpvrSettingsKeys.recording_after_time,
            ctrl.data.value.value
          );
        },
      };

      protectedRec.label = this.subscriptionSettings.titles.deleteProtectTitle;
      protectedRec.value = this.subscriptionSettings.deleteProtected;
      protectedRec.signals = {};
      protectedRec.signals.valueChanged = value => {
        this.backend.cachedNpvrSettings.setSetting(this.backend, NpvrSettingsKeys.recording_delete_protection, value);
      };
    });
  }
}
